<template>
  <span class="back-button pointer p-2" @click="$router.go(-1)">
    <i class="far fa-long-arrow-alt-left pe-2 c-coral"></i>
    <span class="ps-1">{{ backText || $t('GENERAL.LINK.NAVIGATE_BACK') }}</span>
  </span>
</template>

<script>
export default {
  name: 'HMStudioBackButton',
  props: {
    backText: {
      type: String,
    },
  },
};
</script>

<style scoped>
.back-button {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
</style>
